<template>
    <div class="service-trust-indicators">
        <div class="service-trust-indicators__item">
            <svg-icon name="check-circle" />
            <span>{{ $t('service_trust_indicators.vehicle_availability', { count: platformVehiclesCount }) }}</span>
        </div>
        <div class="service-trust-indicators__item">
            <svg-icon name="check-circle" />
            <span>{{
                $t('service_trust_indicators.customer_satisfaction', {
                    numberOfReviews: userReviews.displayedReviewCountRounded,
                    averageScore: userReviews.averageScore,
                })
            }}</span>
        </div>
        <div class="service-trust-indicators__item">
            <svg-icon name="check-circle" />
            <span>{{ $t('service_trust_indicators.insurance_included') }}</span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { actionTypes as configActionTypes } from '~/store/config';

export default {
    name: 'ServiceTrustIndicators',
    async fetch() {
        await this.$store.dispatch(configActionTypes.FETCH_PLATFORM_VEHICLES_COUNT);
    },
    computed: {
        ...mapGetters(['userReviews', 'platformVehicles']),
        platformVehiclesCount() {
            return this.$root.$options.filters.formatAsNumber(this.platformVehicles.roundedCount, 0);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/_variables.scss';

.service-trust-indicators {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px 20px 24px;
    border-bottom: 1px solid $gray;
    background: $white;

    @include lg {
        flex-direction: row;
        justify-content: center;
    }

    .svg-icon {
        width: 24px;
        height: 24px;
        color: $secondary-dark;
    }

    &__item {
        display: flex;
        align-items: center;
        gap: 5px;
        color: #484848;
        font-weight: bold;
    }
}
</style>
